import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StepsModule } from 'primeng/steps'; // Added for ModelSelector upload

// Import shared components
import { ModelSelectorComponent } from '../domes-create/interactive-ar/model-selector/model-selector.component';
import { ThreeJsViewerComponent } from '../domes-create/interactive-ar/threejs-viewer/threejs-viewer.component';
import { ConfirmationDialogComponent } from '../domes-create/interactive-ar/confirmation-dialog/confirmation-dialog.component';

// PrimeNG Modules needed by shared components (will add more as needed)
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FileUploadModule } from 'primeng/fileupload'; // Added for ModelSelector
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup'; // Import ConfirmPopupModule
import { ConfirmationService } from 'primeng/api'; // Import ConfirmationService

@NgModule({
  declarations: [
    ModelSelectorComponent,
    ThreeJsViewerComponent,
    ConfirmationDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    // Add PrimeNG and other modules here
    StepsModule, // Added
    DialogModule,
    ButtonModule,
    InputTextModule,
    ProgressBarModule,
    ToastModule,
    TooltipModule,
    InputNumberModule,
    InputSwitchModule,
    FileUploadModule,
    ConfirmDialogModule,
    ConfirmPopupModule // Add ConfirmPopupModule here
  ],
  exports: [
    ModelSelectorComponent,
    ThreeJsViewerComponent,
    ConfirmationDialogComponent
  ],
  providers: [
    ConfirmationService // Provide ConfirmationService here
    // Shared services if any (e.g., MessageService if used widely)
    // Note: FileUploadService is providedIn: 'root'
  ]
})
export class DomesSharedModule { }